import type { ExperimentConfig } from '../@types'

// Don't start before japanese_water_fasting.landing.* land in web.json — the variant renders raw keys.
const config: ExperimentConfig[] = [
	{
		'main-water-fasting': {
			// /water-fasting?safe&utm_source=FB&country=US&area=main-water-fasting&exp=web_main_water_fasting_japanese~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_main_water_fasting_japanese'
					),
			},
		},
	},
]

export default config
